import { groupByValues } from '@/metrics/constants'

export const searchPlaceholders = {
  [groupByValues.products]: 'Nombre de producto, SKU',
  [groupByValues.variants]: 'Nombre de producto, SKU, variante',
  [groupByValues.categories]: 'Nombre de categoría',
  [groupByValues.types]: 'Nombre de tipo',
  [groupByValues.collections]: 'Nombre de colección',
}

export const minSearchChars = 2
export const searchDebounceMs = 500
